import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export type GetLoyaltyProgramResponse = {
    content: LoyaltyProgramResponseServerItem[]
    total_count: number
    page_size: number
}

export type LoyaltyProgramResponseServerItem = {
    id: string
    rewards_incentive: Maybe<number>
    redemption_minimum: Maybe<number>
    start_date: string
    version: number
}

export const getLoyaltyProgramApi = (headers: Record<string, any>): Rx.Observable<GetLoyaltyProgramResponse> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: "/data/loyalty-program",
            headers: headers,
        })
    ).pipe(retry(3))
